import { FC } from "react";
import { FullBleedSection } from "~/components";
import { useRequiredDiagnosticUser } from "~/hooks/useRequiredDiagnosticUser";
import { useDiagnosticUserProductsIndexQuery } from "~/store/api";
import {
  Title,
  ContentWrapper,
  ToDoListContainer,
  LabTestsContainer,
  ConsultationsContainer,
  Resources,
  OrderTests,
  UnderstandingResults,
} from "./components";
// eslint-disable-next-line no-restricted-imports
import { ToDoCards, LabTestCards, ConsultationCards } from "./features";

const DashboardPage: FC = () => {
  const currentDiagnosticUser = useRequiredDiagnosticUser();
  const { data: userProducts, isLoading: userProductsLoading } = useDiagnosticUserProductsIndexQuery();

  const consultations = userProducts?.flatMap(product =>
    product.consultations.map(consultation => ({
      ...consultation,
      diagnostic_product: product.diagnostic_product
    }))
  ) || [];

  const labTests = userProducts?.flatMap(userProduct =>
    userProduct.lab_tests.map(labTest => ({
      ...labTest,
      diagnostic_product: userProduct.diagnostic_product,
      diagnostic_user_product_id: userProduct.id,
      consultation: labTest.consultation
    }))
  ) || [];

  const shouldShowConsultations = !userProductsLoading && consultations.length > 0;
  const shouldShowLabTests = !userProductsLoading && labTests.length > 0;

  return (
    <FullBleedSection
      bg="bg-main"
      justify="flex-start"
      minH="100vh"
      overflow="hidden"
    >
      <Title />
      <ContentWrapper>
        {!userProductsLoading &&
          <ToDoListContainer>
            <ToDoCards diagnosticUser={currentDiagnosticUser} labTests={labTests} consultations={consultations} />
          </ToDoListContainer>}
      </ContentWrapper>
      {shouldShowLabTests && (
        <LabTestsContainer>
          <LabTestCards diagnosticUser={currentDiagnosticUser} labTests={labTests} />
        </LabTestsContainer>
      )}
      {shouldShowConsultations && (
        <ConsultationsContainer>
          <ConsultationCards consultations={consultations} />
        </ConsultationsContainer>
      )}
      <UnderstandingResults />
      <OrderTests />
      <Resources />
    </FullBleedSection>
  );
};

// eslint-disable-next-line import/no-default-export
export default DashboardPage;
